import { render, staticRenderFns } from "./OrderImportSer.vue?vue&type=template&id=934c3ea4&scoped=true&"
import script from "./OrderImportSer.vue?vue&type=script&lang=js&"
export * from "./OrderImportSer.vue?vue&type=script&lang=js&"
import style0 from "./OrderImportSer.vue?vue&type=style&index=0&id=934c3ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934c3ea4",
  null
  
)

export default component.exports